import React from 'react';
import {isMobile} from 'react-device-detect';
import './Filters.css';


class Filters extends React.Component {
    
    constructor(props) {
        super(props);
        this.parameterRef = React.createRef();
    }

    state = {
        isManufacturerFilterOpen: false, 
        manufacturerTitle: 'Manufacturer',
        selectedManufacturer: null,
        manufacturerList: [],
        systemList: [],
        selectedSystem: null,
        filteredProducts: [],
        selectedProduct: null,
        isLimited: 1,
        isMassSpectrometry: 1,
        isLightSensitive: 1
    }

    cms_url = "https://find.waters.com/WatersCMS/";

    render() {

        const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

        const openManufacturer = () => {
            this.setState({
                isManufacturerFilterOpen: !this.state.isManufacturerFilterOpen
            })
            if(this.state.manufacturerList.length == 0){
                fetch(this.cms_url + "service/vials/outcome/app/all/manufacturers")
                .then(res => res.json())
                .then(
                    (response) => {
                        this.setState({
                            manufacturerList: response.result
                        })
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            }
        }

        const selectManufacturer = (manufacturer) => {
            this.setState({
                manufacturerTitle: manufacturer.display_name,
                selectedManufacturer: manufacturer.manufacturer_id,
                systemList: [],
                selectedSystem: null,
                filteredProducts: [],
                selectedProduct: null,
                isLimited: 1,
                isMassSpectrometry: 1,
                isLightSensitive: 1
            });
            setTimeout(() => {
                if(this.state.systemList.length == 0 && this.state.selectedManufacturer != null){
                    fetch(this.cms_url + "service/vials/outcome/app/filter/systems/"+this.state.selectedManufacturer)
                    .then(res => res.json())
                    .then(
                        (response) => {
                            this.setState({
                                systemList: response.result
                            })
                        },
                        (error) => {
                            console.log(error)
                        }
                    )
                }
            }, 100);
        }

        const selectSystem = (system) => {
            this.setState({
                selectedSystem: system.system_id,
                filteredProducts: [],
                selectedProduct: null,
                isLimited: 1,
                isMassSpectrometry: 1,
                isLightSensitive: 1
            });
            filterProducts();
            if(isMobile) {
                
                setTimeout(() => {
                    console.log(this.parameterRef.current.parentNode,this.parameterRef.current.scrollHeight)
                    window.scroll({
                        top: this.parameterRef.current.parentNode.offsetTop - this.parameterRef.current.scrollHeight + 240
                    })
                }, 200);
            }
        }

        const changeParameter1 = (param) => {
            this.setState({
                isLimited: param
            });
            filterProducts();
        }

        const changeParameter2 = (param) => {
            this.setState({
                isMassSpectrometry: param
            });
            filterProducts();
        }

        const changeParameter3 = (param) => {
            this.setState({
                isLightSensitive: param
            });
            filterProducts();
        }

        const filterProducts = () => {
            setTimeout(() => {
                fetch(this.cms_url + "service/vials/app/filter/"+this.state.selectedManufacturer +'/'+this.state.selectedSystem+'/'+this.state.isLimited+'/'+this.state.isMassSpectrometry+'/'+this.state.isLightSensitive)
                .then(res => res.json())
                .then(
                    (response) => {
                        if(response != null && response.result != null && response.result.length > 0){
                            this.setState({
                                filteredProducts: response.result,
                                selectedProduct: response.result[0]
                            })
                        } else {
                            this.setState({
                                filteredProducts: [],
                                selectedProduct: null
                            })
                        }
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            }, 100);
        }

        const selectProduct = (prdId) => {
            for(let i = 0; i < this.state.filteredProducts.length; i++) {
                if(this.state.filteredProducts[i].id == prdId) {
                    this.setState({
                        selectedProduct: this.state.filteredProducts[i]
                    })
                    break;
                } else {
                    this.setState({
                        selectedProduct: null
                    })
                }
            }
        }
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4">
                    <div className=" sidebar">
                        <div className="box">
                            <p className="primary-clr">Who is the Manufacturer of your system?</p>
                            <ul className="listview" data-title={this.state.manufacturerTitle} id="manufacturer" onClick={openManufacturer}>
                                {this.state.manufacturerList.map((value, index) => {
                                return <li className={this.state.isManufacturerFilterOpen ? 'listview__el show' : 'listview__el'} key={index}>
                                    <a className="listview__link" onClick={() => selectManufacturer(value)}>{value.display_name}</a>
                                </li>
                                })}
                            </ul>
                        </div>
                        <div className={"box " + (this.state.selectedManufacturer == null ? 'hide' : '')}>
                            <p className="primary-clr">Select Your System:</p>
                            <ul className="list-group">
                                {this.state.systemList.map((value, index) => {
                                return <li className="list-group-item decoration-no primary-clr selected" onClick={() => selectSystem(value)} key={index}>
                                    <div className="list-group-item-div">
                                        <img src="/VialSelector/images/circle_legend.png" className={"imgTest " + (this.state.selectedSystem == value.system_id ? 'display-inline' : 'hide')} width="18px" />
                                    </div>
                                    &nbsp;<span className="list-group-item-span">{value.display_name}</span>
                                </li>
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="content-wrapper col-xs-12 col-sm-8 col-md-8">
                    {this.state.selectedSystem != null ? (
                        <div className="pd-lr-15" ref={this.parameterRef}>
                            <h5 className="primary-clr text-italic fs14">Adjust the parameters for your process:</h5>
                            <div className="row">
                                <h4 className="col-sm-4 parameter">Sample Volume (?)</h4>
                                <div className="col-sm-8 no-padding">
                                    <div className="parameter-options">
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isLimited==1 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter1(1)}>
                                                <input type="radio" name="sampleVolume" value="1" id="limited" />
                                            </div>
                                            <label htmlFor="limited" className="cursorPointer parameter" onClick={() => changeParameter1(1)}>Limited</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isLimited==0 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter1(0)}>
                                                <input type="radio" name="sampleVolume" value="0" id="notLimited" />
                                            </div>
                                            <label htmlFor="notLimited" className="cursorPointer parameter" onClick={() => changeParameter1(0)}>Not limited</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <h4 className="col-sm-4 parameter">Use with mass spectrometry (?)</h4>
                                <div className="col-sm-8 no-padding">
                                    <div className="parameter-options">
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isMassSpectrometry==1 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter2(1)}>
                                                <input type="radio" name="massSpectrometry" value="1" id="massSpectrometry" />
                                            </div>
                                            <label htmlFor="massSpectrometry" className="cursorPointer parameter" onClick={() => changeParameter2(1)}>Mass Spectrometry</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isMassSpectrometry==0 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter2(0)}>
                                                <input type="radio" name="massSpectrometry" value="0" id="otherDetector" />
                                            </div>
                                            <label htmlFor="otherDetector" className="cursorPointer parameter" onClick={() => changeParameter2(0)}>Other detector</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <h4 className="col-sm-4 parameter">Light sensitive (?)</h4>
                                <div className="col-sm-8 no-padding">
                                    <div className="parameter-options">
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isLightSensitive==1 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter3(1)}>
                                                <input type="radio" name="lightSensitive" value="1" id="yes" />
                                            </div>
                                            <label htmlFor="yes" className="cursorPointer parameter" onClick={() => changeParameter3(1)}>Yes</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="modelunselected" style={{backgroundPosition: (this.state.isLightSensitive==0 ? '0px 0px':'0px -24px')}} onClick={() => changeParameter3(0)}>
                                                <input type="radio" name="lightSensitive" value="0" id="no" />
                                            </div>
                                            <label htmlFor="no" className="cursorPointer parameter" onClick={() => changeParameter3(0)}>No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="separator"></hr>
                        </div>
                    ) : ('')}
                    {(this.state.filteredProducts.length > 0 && this.state.selectedProduct != null) ? (
                    <div className={'products-wrapper col-sm-12 ' + (this.state.filteredProducts.length == 0 ? 'hide' : '')}>
                        {this.state.filteredProducts.map((value, index) => {
                            return <div className={"col-sm-4 " + (this.state.selectedProduct.id == value.id ? 'active' : 'inactive') + (isMobile ? ' mt-10' : '')
                            + (this.state.filteredProducts.length == 1 ? ' wd-100' : '')
                            + (this.state.filteredProducts.length == 2 ? ' wd-50' : '')
                            + (this.state.filteredProducts.length == 3 ? ' wd-33' : '')
                            + (index == 0 ? ' no-pd-l' : '')} onClick={() => selectProduct(value.id)} key={index}>
                                <div className="card text-centered full-height">
                                    <span className="product-text">{index == 0 ? 'Recommended choice' : 'Alternate choice'}</span>
                                    <div className="productImg">
                                        <img src={value.photo} />
                                    </div>
                                    <span className="partNumber">{value.product_number}</span>
                                    <a href={value.link} className={"btn btn-primary full-width " + (this.state.selectedProduct.id == value.id ? '' : 'hide')} target="_blank">
                                        Go to Product Page
                                    </a>
                                </div>
                            </div>
                        })}
                    </div>
                    ) : ('')}
                    {this.state.selectedProduct != null ? (
                        <div className={"col-sm-12 " + (this.state.selectedProduct == null ? 'hide' : '')}>
                            <div className="product-details-container">
                                <h4 className="product-name">{this.state.selectedProduct.name}</h4>
                                <br />
                                <div className="col-sm-12 fs14" dangerouslySetInnerHTML={{ __html: `${this.state.selectedProduct.description}` }}></div>
                                <br />
                                <span className="text-bold fs14">Detailed specs:</span><br />
                                <br />
                                <table className="full-width fs14">
                                    <tbody>
                                        <tr>
                                            <td>Certification</td>
                                            <td>{this.state.selectedProduct.certification}</td>
                                        </tr>
                                        <tr>
                                            <td>Type</td>
                                            <td>{this.state.selectedProduct.type}</td>
                                        </tr>
                                        <tr>
                                            <td>Cap</td>
                                            <td>{this.state.selectedProduct.cap}</td>
                                        </tr>
                                        <tr>
                                            <td>Septum</td>
                                            <td>{this.state.selectedProduct.septum}</td>
                                        </tr>
                                        <tr>
                                            <td>Material</td>
                                            <td>{this.state.selectedProduct.material}</td>
                                        </tr>
                                        <tr>
                                            <td>Maximum Injection Volume</td>
                                            <td>{this.state.selectedProduct.maximum_injection_volume}</td>
                                        </tr>
                                        <tr>
                                            <td>Residual Volume</td>
                                            <td>{this.state.selectedProduct.residual_volume}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : ('')}
                </div>
            </div>
        );
    }
}

export default Filters;